module.exports = __webpack_public_path__ + "img/home-share.ec257d18.png";